import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../data/site';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  return <section aria-labelledby="reviews-title" className="bg-steel-900 py-20 lg:py-28" data-id="element-233" data-mp="3fze27tb8kvtk">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-234" data-mp="3b0knxyo4l0sc">
        <div id="reviews-title" data-id="element-235" data-mp="3b01gxd00jwt3">
          <SectionHeading eyebrow="Straight From Customers" align="center" title="Word gets around" data-id="element-236" data-mp="3ayqat6j3icyt" />
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-237" data-mp="3205yqo81j1jk">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col border border-white/10 bg-steel-950 p-8" data-id="element-238" data-mp="2x0jlies7plar">
              <Quote className="h-7 w-7 text-brand-light" aria-hidden="true" data-id="element-239" data-mp="2s39p2f6eo9df" />
              <blockquote className="mt-6 flex-1 text-base leading-relaxed text-steel-200" data-id="element-240" data-mp="v8dkrjstq8bc">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-8 border-t border-white/10 pt-6" data-id="element-241" data-mp="q8iwlo0fnwtz">
                <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-242" data-mp="h4n3qbjitzax">
                  {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-brand-light text-brand-light" aria-hidden="true" data-id="element-243" data-mp="780k1q2xleah" data-mpi={i} />)}
                </div>
                <div className="mt-3 font-display text-base font-semibold uppercase tracking-[0.1em] text-white" data-id="element-244" data-mp="zxr044o4iq98">
                  {item.name}
                </div>
                <div className="mt-1 font-mono text-[11px] uppercase tracking-[0.16em] text-steel-400" data-id="element-245" data-mp="q6wgl829i4rh">
                  {item.detail}
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center font-mono text-[11px] uppercase tracking-[0.18em] text-steel-500" data-id="element-246" data-mp="1iu8y33tkfmdx">
          Placeholder reviews — replace with real customer quotes
        </p>
      </div>
    </section>;
}